/**
 * 搜索加人页懒加载壳（14.19b；StickerPacksLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function ContactSearchLazy() {
  const { mod } = useLazyModule(() => import('./ContactSearchPage'));
  if (mod === null) return <div data-testid="contact-search-loading-shell">加载中…</div>;
  return <mod.ContactSearchPage />;
}
